export function getEventMonth(date: Date) {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const eventMonth = monthNames[date.getMonth() ?? 0];
  return eventMonth;
}
export function getEventDay(date: Date) {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const eventDay = days[date.getDay() ?? 0];
  return eventDay;
}
